import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Statistic,
  Spin,
  Col,
  Button,
  Flex,
  Steps
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import dayjs from "dayjs";
import { newGlAccountAction } from "../../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";

// import DetailsForm from "../DetailsForm";
import TermsForm from "./components/TermsForm";
import Preview from "./components/Preview";
import styles from "../../../../assets/styles/styles";
import LoanAccChargeForm from "./components/ChargeForm";
import DetailsForm from "./components/DetailsForm";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewMoneyMarketAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [
    allowPartialPeriodInterestCalcualtion,
    setAllowPartialPeriodInterestCalcualtion,
  ] = useState(false);
  const [isEqualAmortization, setIsEqualAmortization] = useState(false);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [customerId, setCustomerId] = useState([]);
  const [productData, setProductData] = useState([]);
  const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
  const [loanPurposeOptions, setLoanPurposeOptions] = useState([]);
  const [fundOptions, setFundOptions] = useState([]);
  const [termFrequencyTypeOptions, setTermFrequencyTypeOptions] = useState([]);
  const [repaymentFrequencyTypeOptions, setRepaymentFrequencyTypeOptions] =
    useState([]);
  const [
    repaymentFrequencyNthDayTypeOptions,
    setRepaymentFrequencyNthDayTypeOptions,
  ] = useState([]);
  const [
    repaymentFrequencyDaysOfWeekTypeOptions,
    setRepaymentFrequencyDaysOfWeekTypeOptions,
  ] = useState([]);
  const [interestTypeOptions, setInterestTypeOptions] = useState([]);
  const [amortizationTypeOptions, setAmortizationTypeOptions] = useState([]);
  const [
    interestCalculationPeriodTypeOptions,
    setInterestCalculationPeriodTypeOptions,
  ] = useState([]);
  const [
    transactionProcessingStrategyOptions,
    setTransactionProcessingStrategyOptions,
  ] = useState([]);
  const [chargeOptions, setChargeOptions] = useState([]);
  const [loanCollateralOptions, setLoanCollateralOptions] = useState([]);
  const [loanAccountDetails, setLoanAccountDetails] = useState([]);
  const [accountLinkingOptions, setAccountLinkingOptions] = useState([]);
  const [productTemplate, setProductTemplate] = useState([]);
  const [customerParam, setCustomerParam] = useState({});
  const [searchParam, setSearchParam] = useState([]);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [penaltyTableSource, setPenaltyTableSource] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [interestRateFrequencyTypeOptions, setInterestRateFrequencyTypeOptions] = useState([]);

  useEffect(() => { }, []);

  const handleAllowPartialPeriodInterestCalcualtion = (e) => {
    setAllowPartialPeriodInterestCalcualtion(e.target.checked);
  };

  const handleIsEqualAmortization = (e) => {
    setIsEqualAmortization(e.target.checked);
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  const getProductTemplate = (customerParam) => {
    const params = {
      activeOnly: true,
      clientId: customerParam.entityId,
      staffInSelectedOfficeOnly: true,
      templateType: "individual",
    };
    const url = `${apiConfig.LoanAccounts}/template`;

    let body = {
      session,
      params,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        let tempProducts = [];
        let tempLoanOfficerOptions = [];

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.loanOfficerOptions?.forEach((element) => {
          tempLoanOfficerOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        setLoanOfficerOptions(tempLoanOfficerOptions);
        setProductData(tempProducts);
        setShowDetailsForm(true);
        // setCustomerInfo(customerParam);
        setIsLoading(false);
      }
    });
  };

  const onChangeProduct = (productParam) => {
    const params = {
      activeOnly: true,
      clientId: customerInfo.entityId,
      productId: productParam,
      staffInSelectedOfficeOnly: true,
      templateType: "individual",
    };
    const url = `${apiConfig.LoanAccounts}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;

        setLoanAccountDetails(objList);
        setProductTemplate(objList);

        let tempLoanPurposeOptions = [];
        let tempFundOptions = [];
        let tempTermFrequencyTypeOptions = [];
        let tempRepaymentFrequencyTypeOptions = [];
        let tempRepaymentFrequencyNthDayTypeOptions = [];
        let tempRepaymentFrequencyDaysOfWeekTypeOptions = [];
        let tempInterestTypeOptions = [];
        let tempAmortizationTypeOptions = [];
        let tempInterestCalculationPeriodTypeOptions = [];
        let tempTransactionProcessingStrategyOptions = [];
        let tempChargeOptions = [];
        let tempLoanCollateralOptions = [];
        let tempCharges = [];
        let tempPenalty = [];
        let tempInterestRateFrequencyTypeOptions = []

        const tempAccountLinking = [];

        objList?.fundOptions?.forEach((element) => {
          tempFundOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.loanPurposeOptions?.forEach((element) => {
          tempLoanPurposeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.termFrequencyTypeOptions?.forEach((element) => {
          tempTermFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.repaymentFrequencyTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.repaymentFrequencyNthDayTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyNthDayTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.repaymentFrequencyDaysOfWeekTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyDaysOfWeekTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestTypeOptions?.forEach((element) => {
          tempInterestTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.amortizationTypeOptions?.forEach((element) => {
          tempAmortizationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestCalculationPeriodTypeOptions?.forEach((element) => {
          tempInterestCalculationPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.transactionProcessingStrategyOptions?.forEach((element) => {
          tempTransactionProcessingStrategyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargeOptions.push({
            value: element.id,
            label: element.name,
          });
        });


        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",
            feeInterval: element?.feeInterval?.value
              ? element?.feeInterval?.value
              : "-",
          });
        });

        objList?.overdueCharges?.forEach((element, index) => {
          tempPenalty.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              0
            ),
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
          });
        });

        objList?.loanCollateralOptions?.forEach((element) => {
          tempLoanCollateralOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.accountLinkingOptions?.forEach((element) => {
          tempAccountLinking.push({
            value: element.id,
            label: element.productName,
          });
        });

        objList?.interestRateFrequencyTypeOptions?.forEach((element) => {
          tempInterestRateFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setLoanPurposeOptions(tempLoanPurposeOptions);
        setFundOptions(tempFundOptions);
        setTermFrequencyTypeOptions(tempTermFrequencyTypeOptions);
        setRepaymentFrequencyTypeOptions(tempRepaymentFrequencyTypeOptions);
        setRepaymentFrequencyNthDayTypeOptions(
          tempRepaymentFrequencyNthDayTypeOptions
        );
        setRepaymentFrequencyDaysOfWeekTypeOptions(
          tempRepaymentFrequencyDaysOfWeekTypeOptions
        );
        setInterestTypeOptions(tempInterestTypeOptions);
        setAmortizationTypeOptions(tempAmortizationTypeOptions);
        setInterestCalculationPeriodTypeOptions(
          tempInterestCalculationPeriodTypeOptions
        );
        setTransactionProcessingStrategyOptions(
          tempTransactionProcessingStrategyOptions
        );
        setChargeOptions(tempChargeOptions);
        setLoanCollateralOptions(tempLoanCollateralOptions);
        setAccountLinkingOptions(tempAccountLinking);
        setChargeTableSource(tempCharges);
        setPenaltyTableSource(tempPenalty);
        setInterestRateFrequencyTypeOptions(tempInterestRateFrequencyTypeOptions)

        useForm.setFieldsValue({
          principal: objList?.principal,
          fundId: objList?.fundId,
          loanTermFrequency: objList?.termFrequency,
          repaymentEvery: objList?.repaymentEvery,
          numberOfRepayments: objList?.numberOfRepayments,
          interestRatePerPeriod: objList?.interestRatePerPeriod,
          interestType: objList?.interestType?.id,
          repaymentFrequencyType: objList?.repaymentFrequencyType?.id,
          loanTermFrequencyType: objList?.termPeriodFrequencyType?.id,
          amortizationType: objList?.amortizationType?.id,
          interestCalculationPeriodType:
            objList?.interestCalculationPeriodType?.id,
          transactionProcessingStrategyId:
            objList?.transactionProcessingStrategyId,
          maxOutstandingLoanBalance: objList?.maxOutstandingLoanBalance,
          daysInMonth: objList?.daysInMonthType?.value,
          daysinYear: objList?.daysInYearType?.value,
          interestRecalculationCompounding:
            objList?.interestRecalculationData
              ?.interestRecalculationCompoundingType?.value,
          FrequencyForRecalculate:
            objList?.interestRecalculationData?.recalculationRestFrequencyType
              ?.value,
          advancePayments:
            objList?.interestRecalculationData?.rescheduleStrategyType?.value,
          isInterestRecalculationEnabled:
            objList?.isInterestRecalculationEnabled,
          recalculationCompoundingFrequency:
            objList?.interestRecalculationData
              ?.recalculationCompoundingFrequencyType?.value,
          inArrearsTolerance: objList?.inArrearsTolerance,
          allowPartialPeriodInterestCalcualtion:
            objList?.allowPartialPeriodInterestCalcualtion,
          isEqualAmortization: objList?.isEqualAmortization,
          graceOnInterestCharged: objList?.graceOnInterestCharged,
          graceOnPrincipalPayment: objList?.graceOnPrincipalPayment,
          graceOnInterestPayment: objList?.graceOnInterestPayment,
          graceOnArrearsAgeing: objList?.graceOnArrearsAgeing,
          nominalInterestRateFrequency: objList?.interestRateFrequencyType?.value,
          submittedOnDate: dayjs(),
        });
        setIsProductSelected(true);
        setIsLoading(false);
      }
    });
  };

  const onSearch = () => {
    //clear form
    setIsProductSelected(false);
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        // setSearchParam("");
      } else {
        const objList = res;
        let tempProducts = [];

        objList?.forEach((element) => {
          tempProducts.push({
            entityAccountNo: element.entityAccountNo
              ? element.entityAccountNo
              : "",
            entityId: element.entityId ? element.entityId : "",
            entityMobileNo: element.entityMobileNo
              ? element.entityMobileNo
              : "",
            entityName: element.entityName ? element.entityName : "",
            entityType: element.customerType ? element.customerType : "",
          });
        });

        // console.log(tempProducts[0]);
        // return;

        if (tempProducts[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerParam(tempProducts[0]);
        setCustomerInfo(tempProducts[0]);
        getProductTemplate(tempProducts[0]);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.NewMoneyMarketAccount}
        pageItems={staticConfig.newMoneyMarketAccountBreadcrumbs}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {labelConfig.contractSetup}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <NewLoanAccForm
            userData={userData}
            accountLinkingOptions={accountLinkingOptions}
            customerDetail={customerDetail}
            productData={productData}
            onChangeProduct={onChangeProduct}
            loanOfficerOptions={loanOfficerOptions}
            loanPurposeOptions={loanPurposeOptions}
            fundOptions={fundOptions}
            termFrequencyTypeOptions={termFrequencyTypeOptions}
            repaymentFrequencyTypeOptions={repaymentFrequencyTypeOptions}
            repaymentFrequencyNthDayTypeOptions={
              repaymentFrequencyNthDayTypeOptions
            }
            repaymentFrequencyDaysOfWeekTypeOptions={
              repaymentFrequencyDaysOfWeekTypeOptions
            }
            interestTypeOptions={interestTypeOptions}
            amortizationTypeOptions={amortizationTypeOptions}
            interestCalculationPeriodTypeOptions={
              interestCalculationPeriodTypeOptions
            }
            transactionProcessingStrategyOptions={
              transactionProcessingStrategyOptions
            }
            chargeOptions={chargeOptions}
            loanCollateralOptions={loanCollateralOptions}
            loanAccountDetails={loanAccountDetails}
            form={useForm}
            onSearch={onSearch}
            handleSearchInTable={handleSearchInTable}
            customerInfo={customerInfo}
            showDetailsForm={showDetailsForm}
            allowPartialPeriodInterestCalcualtion={
              allowPartialPeriodInterestCalcualtion
            }
            handleAllowPartialPeriodInterestCalcualtion={
              handleAllowPartialPeriodInterestCalcualtion
            }
            isEqualAmortization={isEqualAmortization}
            handleIsEqualAmortization={handleIsEqualAmortization}
            productTemplate={productTemplate}
            isProductSelected={isProductSelected}
            setIsProductSelected={setIsProductSelected}
            chargeTableSource={chargeTableSource}
            setChargeTableSource={setChargeTableSource}
            penaltyTableSource={penaltyTableSource}
            session={session}
            interestRateFrequencyTypeOptions={interestRateFrequencyTypeOptions}
          />
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(NewMoneyMarketAccount);

const NewLoanAccForm = (props) => {
  const {
    userData,
    accountLinkingOptions,
    customerDetail,
    productData,
    onChangeProduct,
    loanOfficerOptions,
    loanPurposeOptions,
    fundOptions,
    termFrequencyTypeOptions,
    repaymentFrequencyTypeOptions,
    repaymentFrequencyNthDayTypeOptions,
    repaymentFrequencyDaysOfWeekTypeOptions,
    interestTypeOptions,
    amortizationTypeOptions,
    interestCalculationPeriodTypeOptions,
    transactionProcessingStrategyOptions,
    chargeOptions,
    loanCollateralOptions,
    loanAccountDetails,
    form,
    onSearch,
    handleSearchInTable,
    customerInfo,
    showDetailsForm,
    allowPartialPeriodInterestCalcualtion,
    handleAllowPartialPeriodInterestCalcualtion,
    handleIsEqualAmortization,
    isEqualAmortization,
    productTemplate,
    isProductSelected,
    chargeTableSource,
    setChargeTableSource,
    penaltyTableSource,
    session,
    interestRateFrequencyTypeOptions
  } = props;

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [collateralTableSource, setCollateralTableSource] = useState([]);
  const [disbursementDataList, setDisbursementDataList] = useState([]);
  const [chargesValue, setChargesValue] = useState(null);
  const [termsValues, setTermsValues] = useState({});

  const [current, setCurrent] = useState(0);
  const [formData, setFormData] = useState({
    details: null,
    terms: null,
    charges: null,
  });

  const onChange = (value) => {
    setCurrent(value);
  };

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  const handleLoanType = (valueParam) => {
    return productTemplate.hasOwnProperty("clientId") &&
      productTemplate.hasOwnProperty("groupId")
      ? (valueParam.loanType = "jlg")
      : productTemplate.hasOwnProperty("clientId")
        ? (valueParam.loanType = "individual")
        : productTemplate.hasOwnProperty("groupId")
          ? (valueParam.loanType = "group")
          : null;
  };

  function onCancel() {
    navigate("/acc0103", { replace: false });
  }

  const onFinishDetailsForm = (values) => {
    values.submittedOnDate = values.submittedOnDate
      ? BOM.DateTime(values.submittedOnDate, "only-date")
      : values.submittedOnDate;

    values.expectedDisbursementDate = values.expectedDisbursementDate
      ? BOM.DateTime(values.expectedDisbursementDate, "only-date")
      : values.expectedDisbursementDate;

    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    values.repaymentsStartingFromDate = values.repaymentsStartingFromDate
      ? BOM.DateTime(values.repaymentsStartingFromDate, "only-date")
      : values.repaymentsStartingFromDate;

    values.interestChargedFromDate = values.interestChargedFromDate
      ? BOM.DateTime(values.interestChargedFromDate, "only-date")
      : values.interestChargedFromDate;

    setFormData({ ...formData, terms: values });

    values.allowPartialPeriodInterestCalcualtion =
      allowPartialPeriodInterestCalcualtion;
    values.isEqualAmortization = isEqualAmortization;
    values.disbursementData = disbursementDataList;
    values.rates = [];

    setCurrent(current + 1);
    setTermsValues(values);
    console.log(values);
  };

  const onFinishChargeForm = (values) => {
    console.log(values);
    let tempChargeArray = [];
    let tempCollateralArray = [];
    chargeTableSource.forEach((element, index) => {
      if (element.feeOnMonthDay === "-") {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
        });
      } else {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
          feeOnMonthDay: BOM.DateTimeWithoutYear(
            element.feeOnMonthDay,
            "only-date"
          ),
        });
      }
    });
    collateralTableSource.forEach((element, index) => {
      tempCollateralArray.push({
        collateral: element.id,
        quantity: element.value,
      });
    });

    values.charges = tempChargeArray;
    values.collateral = tempCollateralArray;

    delete values.chargeId;

    setFormData({
      ...formData,
      charges: values.charges,
      collateral: values.collateral,
    });
    setCurrent(current + 1);
  };

  const onSubmit = (formValues) => {
    formValues = {
      ...formData.details,
      ...formData.terms,
    };

    // STRICT VALUES
    formValues.charges = formData.charges;
    formValues.collateral = formData.collateral;

    // formValues.charges = formData.payLoadValues;
    formValues.clientId = productTemplate.clientId;

    handleLoanType(formValues);

    delete formValues.daysInMonth;
    delete formValues.daysinYear;
    delete formValues.interestRecalculationCompounding;
    delete formValues.FrequencyForRecalculate;
    delete formValues.advancePayments;
    delete formValues.customerSearch;
    delete formValues.isInterestRecalculationEnabled;
    delete formValues.recalculationCompoundingFrequency;
    delete formValues.nominalInterestRateFrequency;

    BOM.AlertMsg(cnt.DANGER, labelConfig.sysErrorMsg);

    return
    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.LoanAccounts, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newLoanAccountMsg);
        navigate("/detail-loan-account", {
          state: {
            id: res.resourceId,
            statusValue: "submitted and pending approval",
          },
        });

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const forms = [
    <DetailsForm
      onFinish={onFinishDetailsForm}
      form={form}
      formData={formData.details}
      accountLinkingOptions={accountLinkingOptions}
      customerDetail={customerDetail}
      productData={productData}
      onChangeProduct={onChangeProduct}
      loanOfficerOptions={loanOfficerOptions}
      loanPurposeOptions={loanPurposeOptions}
      fundOptions={fundOptions}
      loanAccountDetails={loanAccountDetails}
      onSearch={onSearch}
      handleSearchInTable={handleSearchInTable}
      customerInfo={customerInfo}
      showDetailsForm={showDetailsForm}
      termFrequencyTypeOptions={termFrequencyTypeOptions}
      isProductSelected={isProductSelected}
    />,

    <TermsForm
      onFinish={onFinishTermsForm}
      form={form}
      formData={formData.terms}
      termFrequencyTypeOptions={termFrequencyTypeOptions}
      repaymentFrequencyTypeOptions={repaymentFrequencyTypeOptions}
      repaymentFrequencyNthDayTypeOptions={repaymentFrequencyNthDayTypeOptions}
      repaymentFrequencyDaysOfWeekTypeOptions={
        repaymentFrequencyDaysOfWeekTypeOptions
      }
      interestTypeOptions={interestTypeOptions}
      amortizationTypeOptions={amortizationTypeOptions}
      interestCalculationPeriodTypeOptions={
        interestCalculationPeriodTypeOptions
      }
      transactionProcessingStrategyOptions={
        transactionProcessingStrategyOptions
      }
      loanAccountDetails={loanAccountDetails}
      allowPartialPeriodInterestCalcualtion={
        allowPartialPeriodInterestCalcualtion
      }
      handleAllowPartialPeriodInterestCalcualtion={
        handleAllowPartialPeriodInterestCalcualtion
      }
      handleIsEqualAmortization={handleIsEqualAmortization}
      isEqualAmortization={isEqualAmortization}
      productTemplate={productTemplate}
      disbursementDataList={disbursementDataList}
      setDisbursementDataList={setDisbursementDataList}
      interestRateFrequencyTypeOptions={interestRateFrequencyTypeOptions}
    />,

    <LoanAccChargeForm
      onFinish={onFinishChargeForm}
      form={form}
      chargesOptions={chargeOptions}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      loanCollateralOptions={loanCollateralOptions}
      collateralTableSource={collateralTableSource}
      setCollateralTableSource={setCollateralTableSource}
      setChargesValue={setChargesValue}
      penaltyTableSource={penaltyTableSource}
    />,

    <Preview
      formData={formData}
      loanAccountDetails={loanAccountDetails}
      productTemplate={productTemplate}
      customerInfo={customerInfo}
      chargeTableSource={chargeTableSource}
      collateralTableSource={collateralTableSource}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  return (
    <>
      <Row style={{ marginBottom: 25 }}>
        <Col span={24}>
          {/*Interractive Section */}
          <Row style={{ justifyContent: "space-between" }}>
            {/* Navigation section */}
            <Card style={styles.cardSteps}>
              <Steps
                current={current}
                onChange={onChange}
                direction="vertical"
                style={{ height: "600px" }}
                items={[
                  {
                    title: <Text strong>Details</Text>,
                  },
                  {
                    title: <Text strong>Terms</Text>,
                    // disabled: !isProductSelected,
                  },
                  {
                    title: <Text strong>Charges</Text>,
                    // disabled: !isProductSelected,
                  },
                  {
                    title: <Text strong>Preview</Text>,
                    // disabled: !isProductSelected,
                  },
                ]}
              />
            </Card>

            {/* Form Section */}
            <Card style={styles.cardStepDisplay}>
              <div>{forms[current]}</div>
            </Card>
          </Row>
        </Col>
      </Row>

      {/* Submitt section */}
      <Card
        style={{
          marginBottom: 25,
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Flex
          justify="space-between"
          style={{ paddingLeft: "10px", paddingRight: "40px" }}
        >
          {current === 0 && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              colortext="black"
              onClick={onCancel}
            >
              Cancel
            </Button>
          )}
          {current > 0 && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "#15CCAE",
                color: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              onClick={prevButtonClick}
            >
              Prev
            </Button>
          )}
          {!isLastStep && (
            <Button
              style={{
                width: "10%",
                backgroundColor: "#15CCAE",
                color: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                borderRadius: 20,
              }}
              onClick={nextButtonClick}
              disabled={!isProductSelected}
            >
              Next
            </Button>
          )}

          {BOM.HasPermission("CREATE_LOAN") && isLastStep && (
            <CustomButton
              content="Submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              onClick={onSubmit}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
            />
          )}
        </Flex>
      </Card>
    </>
  );
};

